import * as yup from "yup";
import {
  testFloatAndMoney,
  testPositiveFloat,
  testPositiveInteger,
} from "../../../../utilities/form-validation";

export const schema = yup.object().shape({
  barcode: yup.string().required(),
  name: yup.string().required(),
  price: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .required(),
  quantity: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .required("Quantity is required"),

  costPrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)

    .required(),
  taxRate: yup
    .string()
    .test("valid-money", "Invalid Value", testPositiveInteger as any)
    .required(),
});
